import { ReactNode } from 'react';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PriceIcon from './PriceIcon';

type Props = {
  href: string;
  title: string;
  icon?: IconLookup;
  priceIcon?: {
    price: string;
  };
  children?: ReactNode;
};

export default function SpecialDealItem({ href, title, icon, priceIcon }: Props) {
  return (
    <a href={href} className="cursor-pointer inline-flex flex-col items-center justify-center mr-3">
      <div className="w-20 h-20 bg-red-100 rounded-full inline-flex items-center justify-center text-xl">
        {icon && !priceIcon && <FontAwesomeIcon icon={icon} size="2x" className="text-red-600" />}
        {priceIcon && <PriceIcon price={priceIcon.price} />}
      </div>
      <div className="text-[11px] leading-tight font-medium text-center mt-1">{title}</div>
    </a>
  );
}
